import { Info } from 'lucide-react';

import { ModuleCard } from './components/module-card';

import { Alert, AlertDescription } from '@/components/ui/alert';
import { Skeleton } from '@/components/ui/skeleton';
import { useTrainingModules } from '@/hooks/use-training-modules';
import { useEnrichedProgress } from '@/hooks/use-training-progress';

export function ModuleListPage() {
  const { data: modules, isLoading: modulesLoading } = useTrainingModules();
  const { data: progress, isLoading: progressLoading } = useEnrichedProgress();

  const isLoading = modulesLoading || progressLoading;

  if (isLoading) {
    return (
      <div className="mx-auto max-w-3xl space-y-4">
        {Array.from({ length: 3 }).map((_, i) => (
          <Skeleton key={i} className="h-48" />
        ))}
      </div>
    );
  }

  const sorted = [...(modules ?? [])].sort((a, b) => a.order_index - b.order_index);

  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <h1 className="text-2xl font-bold">Training Modules</h1>

      <Alert variant="info">
        <Info className="h-4 w-4" />
        <AlertDescription>
          Modules are designed to be completed in order, but you can start with any module.
        </AlertDescription>
      </Alert>

      <div className="space-y-4">
        {sorted.map((module) => {
          const mp = progress?.modules.find((m) => m.module_id === module.id);
          return <ModuleCard key={module.id} module={module} progress={mp} />;
        })}
      </div>
    </div>
  );
}
